import { lazy } from "react";

// route
export const paymentRoute = { path: "/payment", name: "menu.payment", icon: "payments" };

export const payDebitRoute = { path: `${paymentRoute.path}/debit`, name: "common.debit" };
export const payDebitCreateRoute = { path: `${payDebitRoute.path}/create`, name: "payment.debit.add" };
export const payDebitViewRoute = { path: `${payDebitRoute.path}/view`, name: "payment.debit.detail" };

export const payCreditRoute = { path: `${paymentRoute.path}/credit`, name: "common.credit" };
export const payCreditCreateRoute = { path: `${payCreditRoute.path}/create`, name: "payment.credit.add" };
export const payCreditViewRoute = { path: `${payCreditRoute.path}/view`, name: "payment.credit.detail" };

// component
const Payment = lazy(() => import("../page/payment/Payment"));

const PayDebit = lazy(() => import("../page/payment/debit/Debit"))
// const PayDebitForm = lazy(() => import("../page/payment/debit/form/DebitForm"))
const PayDebitView = lazy(() => import("../page/payment/debit/view/DebitView"))

const PayCredit = lazy(() => import("../page/payment/credit/Credit"))
const PayCreditForm = lazy(() => import("../page/payment/credit/form/CreditForm"))
const PayCreditView = lazy(() => import("../page/payment/credit/view/CreditView"))

export const paymentListRoutes = [payDebitRoute, payCreditRoute];
export const paymentMutationRutes = [
    payDebitCreateRoute, payDebitViewRoute,
    payCreditCreateRoute, payCreditViewRoute
]

export const paymentRoutes = {
    element: <Payment />,
    children: [
        { ...payDebitRoute, element: <PayDebit /> },
        // { ...payDebitCreateRoute, element: <PayDebitForm /> },
        { ...payDebitViewRoute, element: <PayDebitView /> },
        { ...payCreditRoute, element: <PayCredit /> },
        { ...payCreditCreateRoute, element: <PayCreditForm /> },
        { ...payCreditViewRoute, element: <PayCreditView /> },
    ],
}